import TablaConciliacion from "../../../TablaConciliacion";

function TablaBtsconcesionario() {
  return <TablaConciliacion nombreUseCase="BTSCONCESIONARIO" titulo="BTS CONCESIONARIO" />;
}

export default TablaBtsconcesionario;
